/***
 * 创建人：但志强
 * 时间：2019-06-11
 * 描述: 通过指令去绑定事件
 * 更新说明:
 */
import { Directive, HostListener } from '@angular/core';
import { SwWorkFlowService } from './sw-work-flow.service';


/**
 * 点击审核状态 查询审核记录
 * 
 * @example data-id 主键id   data-code:流程关键字  SwWorkFlow开启流程弹出框指令
 * 
 * @example  <td style="width: 100px" data-id={{data.id}} data-code="ckf_collect" SwWorkFlow>{{data.dataState |auditState }}</td>
 */
@Directive({
  selector: '[SwWorkFlow]'
})
export class SwWorkFlowDirective {


  /**
   * @ignore
   * @param workFlow 
   */
  constructor(public workFlow: SwWorkFlowService) { }

  /**
   * @ignore
   */
  ngOnInit(): void {
  }

  // 点击事件
  @HostListener('click', ['$event']) onClick(event) {  //点击的是span 标签,但是属性都在td上
    //获取到表单业务id
    // 如果是直接点击td就直接获取属性
    let fromId = event.target.getAttribute("id");
    let fromId1 = event.target.getAttribute("businessid");
    let code = event.target.getAttribute("data-code");
    let code1 = event.target.getAttribute("keyword");
    let pid = event.target.getAttribute("pid");   //获取 pid ，之后根据 pid 去查审核记录
    let text = event.target.innerText;
    fromId = fromId || fromId1
    code = code || code1
    //所有没拿到id 重新获取 
    if (!fromId) {
      // 如果是点击在span上，就获取它父元素，也就是td上的属性
      fromId = event.target.parentNode.getAttribute("id");
      fromId1 = event.target.parentNode.getAttribute("businessid");
      code = event.target.parentNode.getAttribute("data-code");
      code1 = event.target.parentNode.getAttribute("keyword");
      pid = event.target.parentNode.getAttribute("pid");   //获取 pid ，之后根据 pid 去查审核记录
      text = event.target.parentNode.innerText;
      fromId = fromId || fromId1
      code = code || code1
    }
    if (text == "未提交" || text=="待发布") {
      return;
    }
    // let businessKey = code + ":" + fromId
    let businessKey
    if(pid){
      //如果有pid ，就根据 pid 去查
      businessKey = "procInstId:"+pid
      this.workFlow.showWorkFlow(businessKey);
    } else if(code && fromId){
      // 没有的话就根据 businessKey 去查
      businessKey = code + ":" + fromId
      this.workFlow.showWorkFlow(businessKey);
    }
  }
}

//data-id 主键id   data-code:流程关键字  SwWorkFlow开启流程弹出框指令
//<td style="width: 100px" data-id={{data.id}} data-code="ckf_collect" SwWorkFlow>{{data.dataState |auditState }}</td>
//如果id和code都是循环渲染出来的,不能使用上面的方法绑定,可以使用下面的方法: (id就是businessid , code就是keyword)
//<td [attr.businessid]="data.businessId" [attr.keyword]="data.keyWord" SwWorkFlow [innerHTML]="data.procStatus | procState:data.nextHandler"></td>
// 但在业务中心里面的状态，用businessKey 去查询历史审核记录在有的地方不对，比如说一个删除流程，第一次申请拒绝，第二次申请通过，但在业务中心的状态中两次审核记录都是通过，此时要用pid去查询